import { render, staticRenderFns } from "./DashboardCampaigns.vue?vue&type=template&id=1b51ca7a"
import script from "./DashboardCampaigns.vue?vue&type=script&lang=js"
export * from "./DashboardCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports